import type { ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx/lite'

type Props = {
  badgeBgColor?: string
  badgeTextColor?: string
} & ComponentPropsWithoutRef<'div'>

export function NumberBadge(props: Props) {
  const { children, className, badgeBgColor = '#FFFFFF', badgeTextColor = '#323232', ...rest } = props

  return (
    <div
      className={clsx('flex items-center justify-center rounded-full px-2 text-sm leading-6 shadow-[0_2px_3px_0_rgba(0,0,0,0.12),0_1px_6px_2px_rgba(0,0,0,0.06)]', className)}
      style={{ backgroundColor: badgeBgColor, color: badgeTextColor, fontFamily: '\'Roboto\', sans-serif' }}
      {...rest}
    >
      {children}
    </div>
  )
}
